import { changeToasterState, toggleModal } from '../../../Store/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { useCreateAccountantMutation } from '../../../Store/accountant';
import { TOASTER_STATE } from '../../../Model/Enums';
import { currentCompanySelector } from '../../../Store/paramsBagSlice';
import { SubmitHandler, UseFormRegister } from 'react-hook-form';
import { Accountant } from '../../../Model/Accountant';

export const useAccountantForm = (register: UseFormRegister<Partial<Accountant>>, reset: () => void) => {
  const dispatch = useAppDispatch();
  const currentCompany = useAppSelector(currentCompanySelector);
  const [createAccountant, { isLoading: inProgress }] = useCreateAccountantMutation();

  const onSubmit: SubmitHandler<Partial<Accountant>> = async (data) => {
    try {
      await createAccountant({
        name: data.name,
        email: data.email,
        mobile: data.mobile,
        _id: currentCompany?._id,
      }).unwrap();
      dispatch(changeToasterState(TOASTER_STATE.ENTREPRENEUR_SAVE_OR_EDIT_SUCCESS));
      reset();
    } catch (e) {
      dispatch(changeToasterState(TOASTER_STATE.ACCOUNTANT_CREATED_FAILED));
    } finally {
      dispatch(toggleModal());
    }
  };

  return { onSubmit, inProgress };
};
